import {
  makeStyles,
  Typography
} from "@material-ui/core";
import _ from "lodash";
import React, {  } from "react";
import { useStoreState } from "../../../../models/RootStore";
import groupPanelStyles from "./SensorGroupPanel.style";
import { SensorThumbnail } from "../../../../screens/Control/ControlComponents/SensorThumbnail";

const SensorGroupPanel: React.FC<any> = (props) => {
  const {
    group,
    isCelsius,
    siteTemp,
    tempSymbol,
  } = props;

  const {
    name: groupName = "",
    sensors: groupSensors,
  } = group || {};

  const useStyles = makeStyles(groupPanelStyles);
  const classes = useStyles();
  const allSensors = useStoreState((state) => state.sensors.allSensors);

  return (
    <div className={classes.groupView}>
      <div className={classes.firstRowContainer}>
        <Typography className={classes.siteTemp}>{(isCelsius ? siteTemp.C || "" : siteTemp.F || "") + " "}<span className={classes.scaleStyle}>{siteTemp.C && tempSymbol || ""}</span></Typography>
        <div className={classes.nameSection}>
          <Typography>{groupName}</Typography>
        </div>
      </div>

      <div className={classes.secondRowContainer}>
        {
          groupSensors?.map((sensorId: string, index: any) => {
            const sensorObj = allSensors[sensorId];
            if (!sensorObj) {
              return;
            }
            return (
              <SensorThumbnail
                key={`sensorThumb-${sensorId}`}
                sensor={sensorObj}
                isCelsius={isCelsius}
              />
            );
          })
        }
      </div>
    </div>
  );
};

export default SensorGroupPanel;
